import React from 'react'
import * as PropTypes from "prop-types"
import Helmet from 'react-helmet'
import Img from "gatsby-image"

import "./index.css"
var layout = require("./layout.module.css");

const propTypes = {
  children: PropTypes.func.isRequired,
}

class DefaultLayout extends React.Component {
  render() {
    return (
      <div className={layout.wrapper}>
        <div id="contentContainer" className={layout.content}>
          <a href="/">
            <img className={layout.logo} src="/images/logo2.svg" width="100" height="66" />
          </a>
          {this.props.children()}
        </div>
        {/*
        <div className={layout.privacyContainerShow}>
          <div className={layout.privacy}>
            <span className={layout.privacyText}>
              <strong>Please note:</strong> We use cookies on our site to give you the best experience. Please accept these cookies, or change your settings here: <a class="" href="#">Cookie preferences</a>.
            </span>
            <a href="" className={layout.privacyButton}>I accept</a>
            <a href="#" className={layout.privacyClose}>Close</a>
          </div>
        </div>
        */}
      </div>
    )
  }
}

DefaultLayout.propTypes = propTypes

export default DefaultLayout



// WEBPACK FOOTER //
// ./src/layouts/index.js